<template>
  <div class="m-form">
    <fieldset class="m-fieldset">
      <label for="iname"> label </label>
      <input type="text" name="name" id="iname" :placeholder="i18n.iname" v-model="nm" data-i18n-placeholder="contact.form.name" >
    </fieldset>
    <fieldset class="m-fieldset">
      <label for="imail"> label </label>
      <input type="email" name="mail" id="imail" v-model="ml" :placeholder="i18n.imail" data-i18n-placeholder="contact.form.email" >
    </fieldset>
    <fieldset class="m-fieldset">
      <label for="imail"> phone </label>
      <input type="email" name="tel" id="itel" v-model="mtel" :placeholder="i18n.iphone"   >
    </fieldset>
    <fieldset class="m-fieldset">
      <label for="imes">label</label>
      <textarea id="imes" v-model="tx" :placeholder="i18n.itext" data-i18n-placeholder="contact.form.message" ></textarea>
    </fieldset>

    <button v-if="mres" disabled > {{mres}} </button>
    <button v-else @click="mdo">Send</button>
  </div>
</template>
<script>
    export default {
        name: "ContactForm",
        props: {
            apibase: {
                required: true,
                type: String,
            },
            mlang:{
                required:false,
                type:String,
                default( ) { return 'en'  }
            },
            msrc:{
                required:false,
                type:String,
                default( ) { return 'matrix_site'  }
            },
            i18n: {
                required: false,
                type: Array,
                default( ) {  return []  }
            },


        },
        data: function () {
            return {
                nm:'',
                ml:'',
                tx:'',
                mtel:'',
                mres:''
            }
        },
        methods: {
          mdo(){
              this.mres = ' ⏳ Sending...';
              if(this.nm && this.ml )
              axios.post(  this.apibase +'/ext/registration' ,{mform:{tel:this.mtel, mcli: this.nm, mmal: this.ml,mtxt: this.tx,mflg: 123,src:this.msrc,lang:this.mlang } }, {withCredentials: true} )
                  .then(response => {
                      this.mres = 'Invitation has been sent to the specified address';
                      console.log('response', response.data.message );
                  })
                  .catch(error => {
                      console.log('error ', error.toString() );
                      this.mres = 'Application error';
                  });
              else this.mres = 'Invitation has been sent to the specified address';
          }
        },
    }
</script>
<style  >
.m-form {
  display: grid;
  grid-gap: 12px;
  background: transparent;
}
.m-fieldset {
  display: flex;
  border: none;
  margin: 0;
  outline: none;
  padding: 0;
}
.m-form input::placeholder, textarea::placeholder{color:rgba(66,66,66,.8);}
.m-form input , .m-form textarea {
  background: var(--card,white);
  border: 1px solid silver;
  border-radius: 12px;
  padding: 12px 14px;
  color: var(--text,black);
  outline: none;
  flex-grow: 1;
}
  .m-form textarea {
    min-height: 120px;
    resize: vertical;
  }

  .m-form button {
    display: inline-block;
    padding: 14px 22px;
    border-radius: 14px;
    background: linear-gradient(135deg, var(--accent,#00e5ff), var(--accent-2,#0061ff));
    color: #001018;
    font-weight: 700;
    box-shadow: 0 0 24px rgba(0,229,255,.35);
    transition: .25s transform ease, .25s box-shadow ease ;
  }
.m-form label {
  overflow: hidden;
  font-size: 0;
}
</style>
